import React, { useContext, useEffect, useState } from 'react';

import { Typography, Stack } from '@mui/material';
import moment from 'moment';
import 'moment/locale/es';
import { getDataNotificacionAsync } from '../../../../api/Credits';
import { getToken } from '../../../../api/Account';
import { simpleMessage } from '../../../../helpers/Helpers';
import { conv2Letras } from '../../../../helpers/n2Letras';
import { DataContext } from '../../../../context/DataContext';
import './notification.css';

export const PrintNotificacionExtrajudicial = React.forwardRef((props, ref) => {
	const [data, setData] = useState([]);
	const { title, slogan, icon, setIsLoading, setIsUnautorized } = useContext(DataContext);
	const { id } = props;
	const token = getToken();

	const getPageMargins = () => {
		return `body {
              color:black;
            }`;
	};

	useEffect(() => {
		getDataCredit();
	}, []);

	const getDataCredit = async () => {
		setIsLoading(true);
		const result = await getDataNotificacionAsync(token, id);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}

		setData(result.data.result);
		setIsLoading(false);
	};

	const hoy = moment().locale('es');
	const montoVencido = new Intl.NumberFormat('es-NI', {
		style: 'currency',
		currency: 'NIO'
	}).format(data.atraso || 0);

	return (
		<div ref={ref} className="nce">
			<style>{getPageMargins()}</style>

			{data.length === 0 ? null : (
				<>
					<div className="nce-watermark">credito en mora</div>

					<Stack direction="row" justifyContent="space-between">
						<img src={icon} style={{ width: 70, height: 70 }} />
						<Stack>
							<Typography variant="h5" color="#212121" textAlign={'center'}>
								{title}
							</Typography>
							<Typography color="#212121" textAlign={'center'}>
								{slogan}
							</Typography>
						</Stack>
						<img src={icon} style={{ width: 70, height: 70 }} />
					</Stack>

					<hr />

					<h6 className="nce-title">NOTIFICACIÓN DE COBRO EXTRAJUDICIAL</h6>

					<div className="nce-meta">
						<p>
							<strong>Fecha:</strong> {hoy.format('D')} de {hoy.format('MMMM')} de{' '}
							{hoy.format('YYYY')}
						</p>
						<p>
							<strong>Referencia / No. de Crédito:</strong> {data.id}.
						</p>
						<p>
							<strong>Asunto:</strong> Requerimiento de Pago Extrajudicial
						</p>
					</div>

					<div className="nce-meta">
						<p>
							<strong>A la atención de:</strong>
						</p>
						<p>
							<strong>Cliente:</strong> {data.fullName}.
						</p>
						<p>
							<strong>Dirección:</strong> {data.address}.
						</p>
						<p>
							<strong>Teléfono:</strong> {data.phone}.
						</p>
					</div>

					<div className="nce-body">
						<p>Estimado(a):</p>

						<p>
							Por medio de la presente, nos dirigimos a usted en representación de{' '}
							<strong>{title}</strong> para hacer de su conocimiento el estado crítico
							de su cuenta correspondiente al crédito de referencia.
						</p>

						<p>
							A la fecha de emisión de esta notificación, nuestro departamento de
							cartera registra un saldo vencido y pendiente de pago por la cantidad de{' '}
							<strong>{montoVencido}</strong> (
							<strong>{conv2Letras(data.atraso || 0)}</strong>), presentando un atraso
							de <strong>{data.atrasoDias}</strong> días.
						</p>

						<p>
							A pesar de los intentos previos de contacto y las facilidades otorgadas
							por nuestros gestores para regularizar su situación de manera ordinaria,
							no hemos recibido el pago correspondiente ni una propuesta formal de
							Cancelación.
						</p>

						<p>
							<strong>Implicaciones de la Omisión de Pago.</strong>
						</p>

						<p>
							Le recordamos que el incumplimiento prolongado de sus obligaciones
							contractuales faculta a <strong>{title}</strong> a iniciar las siguientes
							acciones:
						</p>

						<ol className="nce-list">
							<li>
								<strong>Entrega de garantías:</strong> requerimiento de cumplimiento de
								bienes en prenda ofrecidos como respaldo en la cláusula de garantías
								del contrato inicial.
							</li>
							<li>
								<strong>Reporte Negativo:</strong> Afectación de su historial crediticio
								ante las centrales de riesgo y burós de crédito.
							</li>
							<li>
								<strong>Traslado a Instancia Legal:</strong> Envío del expediente a
								nuestro cuerpo de abogados para el cobro por la vía judicial, lo cual
								genera gastos de cobranza, costos judiciales e intereses moratorios
								adicionales.
							</li>
						</ol>

						<p className="nce-firma">
							<strong>Atentamente: Departamento de Crédito y Cobranzas {title}.</strong>
						</p>

						<p className="nce-telefonos">
							<strong>8467-1371</strong>
							<strong>7865-8057</strong>
						</p>
					</div>
				</>
			)}
		</div>
	);
});

export default PrintNotificacionExtrajudicial;
